import { ServiceType } from '../components';

export type CrawlRequestStatus = 'PROCESSING' | 'SUCCESS' | 'FAILED';

export enum CrawlRequestGrouping {
  COMPANY = 'COMPANY',
  PERSON = 'PERSON',
}

export interface CrawlRow {
  id: string;
  name: string;
  url: string;
  modified: string;
  status: CrawlRequestStatus;
  grouping: CrawlRequestGrouping;
  metadata: CreateCrawlRequestMetadata;
}

export interface CreateCrawlRequestMetadata {
  type?: ServiceType;
}
export interface CreateCrawlRequestRequest {
  url: string;
  grouping: CrawlRequestGrouping;
  metadata: CreateCrawlRequestMetadata;
}

export interface CreateCrawlRequestResponse {
  id: number;
  name: string;
  url: string;
  modified: string;
  status: CrawlRequestStatus;
  grouping: CrawlRequestGrouping;
}
